/** @module app.test.pages */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';

@autoinject
export class TestEssDatetime extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    protected dateTime: string = '';
    protected readonly: boolean = false;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    //constructor(...rest: any[]) { super(...rest); }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////

    protected toggleReadonly() {
        this.readonly = !this.readonly;
    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
